import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { RiskChipProps } from "./RiskChipProps";

export const riskChipStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            borderRadius: theme.shape.borderRadius,
            color: theme.colors.neutrals.neutral600,
            ...theme.typography.subtitle2,
            textTransform: "capitalize",
            height: "initial",

            backgroundColor: ({ riskLevel }: RiskChipProps) => {
                switch (riskLevel) {
                    case "high":
                        return theme.colors.feedback.error;
                    case "medium":
                        return theme.colors.feedback.warning;
                    case "low":
                        return theme.colors.feedback.success;
                    case "healthy":
                        return theme.colors.feedback.health;
                }
            },

            "& span": {
                padding: theme.spacing("6px", "8px"),
            },
        },
    })
);
